import React from 'react';
import { StyledHeroWrapper } from './HeroStyles';

export const Hero = () => {
  return (
    <StyledHeroWrapper>
      <div className="right">
        <section className="copy">
          <h1>WOODEN TOYS</h1>
          <h3>Juguetes de madera</h3>
          <p>Para la primera infancia</p>
        </section>
      </div>
      <div className="left ml-4"> </div>
    </StyledHeroWrapper>
  )
}


